
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartShallowContourProposal as ObiChartShallowContourProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-shallow-contour-proposal.js';
 
 
 

 
 export const ObiChartShallowContourProposal = createComponent({
   react: React,
   tagName: 'obi-chart-shallow-contour-proposal',
   elementClass: ObiChartShallowContourProposalElement,
   events: {
     
   }
  });
 
 